/**************************************************************************************************************************************************
*   MODULE NAME     :  DateFormat
*   AUTHOR          :  GLSD DEV Team
*   DATE            :  05-01-2021
*   DESCRIPTION     :  All positive workflow logic(format date -: MM-DD-YYYY , YYYY-MM-DD)
*   Copyright 2021 Eli Lilly and Company
*   All rights reserved
*
/**************************************************************************************************************************************************
*   *** CHANGE HISTORY ***
/**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG1689267
*   DESCRIPTION: <GLSD>: New System Development
/**************************************************************************************************************************************************/

    /**
       * Function to handle date format(MM-DD-YYYY)
    **/

const dateFormat = (inputFormat) => {
    function pad(s) { return (s < 10) ? '0' + s : s; }
    var d = new Date(inputFormat);
    return [pad(d.getMonth() + 1), pad(d.getDate()), d.getFullYear()].join('/');
};

    /**
       * Function to handle date format(YYYY-MM-DD)
    **/

export const yyyymmddFormat = (inputFormat) => {
    function pad(s) { return (s < 10) ? '0' + s : s; }
    var d = new Date(inputFormat);
    return [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join('-');
};

export const ddmmmyyyyFormat = (inputFormat, time = false) => {
    function pad(s) { return (s < 10) ? '0' + s : s; }
    let d = new Date(inputFormat);
    let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    let date = [pad(d.getUTCDate()),months[d.getUTCMonth()],d.getUTCFullYear()].join('-');
    if(time) date = date + " " + [pad(d.getUTCHours()),pad(d.getUTCMinutes()),pad(d.getUTCSeconds())].join(":");
    return date
}
export default dateFormat;

